import { useEffect, useState } from "react";

/**
 * Hook that counts down to a target date/time
 * @param targetDate - The target date to count down to
 * @returns The remaining seconds (0 when countdown is complete)
 */
export function useCountdown(targetDate: Date | null): number {
  const [remainingSeconds, setRemainingSeconds] = useState<number>(0);

  useEffect(() => {
    if (!targetDate) {
      setRemainingSeconds(0);
      return;
    }

    const calculateRemaining = () => {
      const now = Date.now();
      const target = targetDate.getTime();
      const diff = target - now;

      if (diff <= 0) {
        return 0;
      }

      return Math.floor(diff / 1000);
    };

    setRemainingSeconds(calculateRemaining());

    const interval = setInterval(() => {
      const remaining = calculateRemaining();
      setRemainingSeconds(remaining);

      if (remaining <= 0) {
        clearInterval(interval);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [targetDate]);

  return remainingSeconds;
}
